import React, { Component } from 'react';
import ScrollFadeIn from "./../../components/scrollFadeIn";
import {Helmet} from "react-helmet";

export default class BlogDetail extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <title>{'Kat Medina Blog | Articles | Observations'}</title>
          <meta name="description" content="Lessons from a Dog Named Donut article by Kat Medina, author of the book, The Joys of Jet Lag." />
        </Helmet>
        <ScrollFadeIn>
          <p className="tiny-padding">{'A couple of weeks ago my dog turned a whopping five years old. He’s a 75-pound overly excitable furball who gets his kicks from car rides, dental chew sticks, and butt rubs. His name is Donut and over the last half-decade, he has taught me more than I can properly articulate.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'As with any monumental birthday, the big 3-5 in dog years prompted some reflection on my part. First off, where the fuck did the last five years go?! It seems like unless we occasionally pause and acknowledge the time that’s passing, it just keeps flying by.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Donut doesn’t seem to mind though.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'He may be a teeny tiny bit more mellow now, but for the most part, he just continues to take each day as it comes. He lives fully and naps often. He could be dead asleep and if I say his name and act super excited and silly he joins in at 100% in an instant. He doesn’t need a reason to be excited and happy, he just is. He lets go of upsets quickly, focusing solely on the present and accepts it without hesitation.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'When he was about six months old he was neutered and had to wear a cone for about a week. That first day in the cone of shame he was pretty bummed out and confused. One day he was a normal dog, and the next, his head was basically the olive in a large plastic martini glass. His depth perception with the cone was all out of wack and he kept bumping into door frames and ramming the edge of it into the backs of my knees (I’m still not sure if this was out of vengeance for the whole Donut to Do-nutless thing though).'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'The following morning something interesting happened. He woke up excited, then remembered his new limitation, and then let it go and was excited again. There was no way of him knowing that his suffering would be over in about a week. For all he knew, it was permanent. He accepted his fate as Conut, and chose to live with the same joy and zest for life as before.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'I was in awe of his resilience. What if I started to accept reality and chose to be joyful regardless of life’s difficulties, instead of letting some unexpected problems darken my mood?'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Donut is a Golden Retriever and I am 99.99% sure he believes he is a short hairy human, just one of the gang. If I have friends over and we are standing around in a circle talking, he tends to sit alongside us and watches whoever is speaking with deep intensity, tail wagging whenever he recognizing a word (treat, food, dinner, breakfast...catch a theme here?). When the speaker looks him in the eye, they immediately smile because Donut is beaming at their acknowledgment. It seems joy and love is contagious.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'He uplifts the moment by participating in it full out. He is a happy dog and when we walk down the street, he has a domino effect of smiles. People pass by walking or driving and when they look at him he wags fiercely and gives them a gift of smiles. It’s incredible to see the immediate effect on their faces–joy embodied in an instant just from the look from a dog.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'His positivity and silliness lighten up even the most difficult of situations. If someone is sad, he gravitates towards them and leans against their legs, focused on being fully available for whoever is suffering.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'Donut lives with absolute presence. He doesn’t get consumed by the past or lost in the future. He is 100% here now, as authentic as possible because he doesn’t know how to be anything but his true self. He doesn’t take life or himself too seriously. He is a seeker and finder of fun and gives love freely and unconditionally.'}
          </p>
        </ScrollFadeIn>
        <ScrollFadeIn>
          <p className="tiny-padding">{'I’m eternally grateful for this sweet soul because, from the first day he came into my life, he has given me the most incredible gift: A shining example of what it is to live from a place of unbridled joy, openheartedness, and love without limits. He has shown me how to live fully.'}
          </p>
        </ScrollFadeIn>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/blogDetail/donut.js